import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { BaseError } from './BaseError';

export class UserActivationMissingError extends BaseError {
  public override readonly description = _('server.error.auth.user_activation_missing');
  protected override errorCode = 'user-activation-missing';
}
